__turbopack_context__.v({
  "toolkit-item-card": "toolkit-item-card-module-scss-module__KqJQwa__toolkit-item-card",
  "toolkit-item-card__actions-container": "toolkit-item-card-module-scss-module__KqJQwa__toolkit-item-card__actions-container",
  "toolkit-item-card__icon": "toolkit-item-card-module-scss-module__KqJQwa__toolkit-item-card__icon",
  "toolkit-item-card__image": "toolkit-item-card-module-scss-module__KqJQwa__toolkit-item-card__image",
  "toolkit-item-card__title": "toolkit-item-card-module-scss-module__KqJQwa__toolkit-item-card__title",
});
